import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DynamicCurrencyPipe } from './pipes/dynamic-currency.pipe';
import { SubscriptionTermsDaysFrequencyPipe } from './pipes/subscription-terms-days-frequency.pipe';
import { VideoPlayerVidalyticsComponent } from 'src/components/video-player-vidalytics/video-player-vidalytics';

@NgModule({
  declarations: [DynamicCurrencyPipe, SubscriptionTermsDaysFrequencyPipe, VideoPlayerVidalyticsComponent],
  exports: [DynamicCurrencyPipe, SubscriptionTermsDaysFrequencyPipe, VideoPlayerVidalyticsComponent],
  imports: [CommonModule],
  providers: [DynamicCurrencyPipe, SubscriptionTermsDaysFrequencyPipe] 
})
export class SharedModule {}